import React from 'react'

// GraphQL
import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationError, // via withFormResults
      onMutationCompleted // via withFormResults
    } = props

    // setup GraphQL mutation
    const [updatePreferences, { loading }] = useMutation(mutation, {
      onError: onMutationError,
      onCompleted: onMutationCompleted
    })

    return (
      <WrappedComponent
        loading={loading}
        updatePreferences={updatePreferences}
        {...props}
      />
    )
  }
}

export default withMutation
